import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-12 md:pt-24 md:pb-16 overflow-hidden" data-id="element-101">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-amber-400/10 blur-[120px] rounded-full pointer-events-none" data-id="element-102" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-103">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-104">
          {/* Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-105">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/10 border border-amber-400/20 text-amber-300 text-xs md:text-sm font-medium tracking-wide mb-6" data-id="element-106">
              <Star className="w-3 h-3 fill-amber-300" data-id="element-107" />
              <span data-id="element-108">Reset de 14 días para parejas</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight text-cream-100 mb-6" data-id="element-109">
              De <span className="text-amber-400 italic" data-id="element-110">"somos roomies"</span>{' '}
              a <span className="text-amber-400 italic" data-id="element-111">"somos pareja"</span> en
              14 días.
            </h1>

            <p className="text-lg md:text-xl text-cream-200/80 mb-8 leading-relaxed max-w-xl mx-auto md:mx-0" data-id="element-112">
              Sin terapia. Sin conversaciones eternas que terminan en pelea.
              Solo un sistema simple para volver a conectar.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start" data-id="element-113">
              <Button size="lg" href="#pricing" className="w-full sm:w-auto group" data-id="element-114">
                Quiero el Reset Anti-Roomies
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-115" />
              </Button>
              <p className="text-sm text-cream-200/60" data-id="element-116">Acceso inmediato</p>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md md:max-w-full relative" data-id="element-117">
            <div className="relative rounded-xl overflow-hidden shadow-2xl border border-charcoal-600/50 bg-charcoal-800" data-id="element-118">
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/80 to-transparent z-10" data-id="element-119" />
              <img src="https://cdn.magicpatterns.com/uploads/3fU5ZjVfpzcjMyZoR7gRwd/anti-roomies-ebook.png" alt="Anti-Roomies Ebook en tablet" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-120" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-amber-400/20 blur-2xl rounded-full" data-id="element-121" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-amber-400/10 blur-2xl rounded-full" data-id="element-122" />
          </div>
        </div>
      </div>
    </section>;
}